import { render, staticRenderFns } from "./AddMultipleExtraCostsModal.vue?vue&type=template&id=313c0b96&scoped=true&"
import script from "./AddMultipleExtraCostsModal.vue?vue&type=script&lang=js&"
export * from "./AddMultipleExtraCostsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddMultipleExtraCostsModal.vue?vue&type=style&index=0&id=313c0b96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c0b96",
  null
  
)

export default component.exports